import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';

export type Colors = Array<{ name: string; code: string }>;

@Component({
  selector: 'nw-project-settings',
  templateUrl: './project-settings.component.html',
  styleUrls: ['./project-settings.component.scss'],
})
export class ProjectSettingComponent {
  @Output()
  exit = new EventEmitter();

  constructor(private readonly store: Store) {}
}
